<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto page-card self-center reset-password">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto  self-center">
              <!-- <img src="@/assets/images/pages/register.png" alt="login" class="mx-auto"> -->
              <img src="@/assets/images/logo/logo.png"  alt="login" class="mx-auto page-logo">
              <img src="@/assets/images/pages/banner-img.svg" alt="login" class="mx-auto page-image">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center bg-white">
              <div class="p-8">
                <div>
                  <form autocomplete="off">
                    <div class="vx-card__title mb-8">
                      <h2 class="mb-4">Reset Password</h2>
                      <p>Enter OTP to reset password.</p>
                    </div>
                    <div>
                      <vs-input
                        icon="icon icon-user"
                        v-validate="'required'"
                        name="otp"
                        type="number"
                         @keydown="filterKey"
                        icon-pack="feather"
                        label-placeholder="Enter OTP"
                        v-model="token"
                        class="w-full no-icon-border"
                      />
                      <span class="text-danger text-sm">{{ errors.first('otp') }}</span>
                    </div>
                    <div class="">
                      <vs-input
                        class="w-full no-icon-border"
                        icon-pack="feather"
                        ref="password"
                        icon="icon icon-lock"
                        type="password"
                        label-placeholder="New Password"
                        v-validate="'required|verify_password|min:8|max:20'"
                        name="password"
                        v-model="new_password"
                      />
                      <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                    </div>

                    <div class="">
                      <vs-input
                        class="w-full no-icon-border"
                        icon-pack="feather"
                        icon="icon icon-lock"
                        type="password"
                        label-placeholder="Confirm New Password"
                        v-validate="'required|confirmed:password'"
                        name="password_confirmation"
                        v-model="confirm_password"
                      />
                      <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
                    </div>
                    <button
                      type="button"
                      class="vs-component vs-button float-right mt-6 ml-2 vs-button-warning vs-button-filled"
                      @click.prevent="back()"
                    >Back</button>
                    <vs-button
                      class="float-right mt-6"
                      id="reset-password"
                      :disabled="button_loading"
                      @click.prevent="updatePassword()"
                    >Submit</vs-button>
                  </form>
                </div>
                <vs-divider position="center" class="my-8"></vs-divider>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
 Validator.extend('verify_password', {
        //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
        validate: value => {
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(value);
        }
    });
const dict = {
  custom: {
    otp: {
      required: "Please enter OTP"
    },
    password: {
      required: "New password is required",
     min: "Password should be minimum 8 characters",
      verify_password: "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Confirm password is required",
      confirmed: "Confirm password and New password should be same"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  data() {
    return {
      email: "",
      new_password: "",
      confirm_password: "",
      token: ""
    };
  },
  mounted() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
    /*  if (this.$route.query.email && this.$route.query.token) {
      this.email = this.$route.query.email;
      this.token = this.$route.query.token;
    } else {
      this.$router.push({ name: "login" });
    } */
  },
  methods: {
    updatePassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#reset-password");
          let input = {
            otp: this.token,
            email: this.email,
            newPassword: this.new_password
          };
          this.axios
            .post("auth/setPassword", input)
            .then(response => {
              this.button_loader(false, "#reset-password");
              let text = "Your password has been reset successfully.";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              this.$router.push({ name: "login" });
            })
            .catch(e => {
              this.showError(e, "#reset-password");
            });
        }
      });
    },
    back() {
      history.back();
    }
  }
};
</script>
<style>
.reset-password .vs-divider-border {
  border: 0 !important;
}

.page-card
{
  align-items: center;
    display: flex;
}
.page-logo {
  max-width: 240px;
}
.page-image {
  max-width: 350px;
}
</style>
